export default ({ $axios, $auth }) => {
  $axios.onRequest(config => {
    // Skip auth endpoints
    if (config.url && (config.url.includes('/auth/login') || config.url.includes('/auth/autologin'))) {
      return config;
    }

    let token = null;
    
    // Try multiple sources in order
    if (typeof window !== 'undefined') {
      // 1. localStorage
      token = localStorage.getItem('access_token');
      
      // 2. Auth module
      if (!token && $auth && $auth.strategy && $auth.strategy.token) {
        const authToken = $auth.strategy.token.get();
        if (authToken) {
          token = authToken.replace('Bearer ', '');
        }
      }
      
      // 3. Cookie
      if (!token) {
        const cookies = document.cookie.split(';');
        const authCookie = cookies.find(cookie => cookie.trim().startsWith('auth_token='));
        if (authCookie) {
          token = authCookie.split('=')[1];
        }
      }
    }
    
    if (token && token !== 'undefined' && token !== 'null' && token.length > 10) {
      config.headers.Authorization = `Bearer ${token}`;
      // OC studio tokens are bearer-only and intentionally do not forward
      // merchant dashboard cookies to the Tajadad API origin.
      config.withCredentials = !localStorage.getItem('oc_editor_expires_at');
    }
    
    return config;
  });

  $axios.onResponseError(async error => {
    const response = error && error.response;
    const config = error && error.config;
    const canRenew = typeof window !== 'undefined'
      && typeof window.__RENEW_TAJADAD_EDITOR_SESSION__ === 'function';

    if (!response || response.status !== 401 || !config || config.__tajadadSessionRetried || !canRenew) {
      return Promise.reject(error);
    }

    config.__tajadadSessionRetried = true;

    try {
      const session = await window.__RENEW_TAJADAD_EDITOR_SESSION__();
      const token = session && session.access_token
        ? session.access_token
        : localStorage.getItem('access_token');

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return $axios.request(config);
    } catch (renewalError) {
      return Promise.reject(error);
    }
  });
}
